"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.collisionSheetCollisionTiers = exports.makeCollisionSheetImpliques = exports.collisionSheetImpliquesExcel = exports.makeCollisionSheetTiers = exports.collisionSheetTiersExcel = exports.collisionSheetCollisionObstacles = exports.collisionSheetTemoins = exports.makeCollisionSheetTemoins = exports.collisionSheetTemoinsExcel = exports.collisionSheetCollision = void 0;
exports.collisionSheetCollision = [
    {
        '@type': 'uuid-string',
        key: 'f93ce5cd-ede6-44b1-9b29-6b05516d3b8a',
        label: "Lieu d'intervention",
        value: bilan => bilan?.fiche_collision?.lieu_intervention,
    },
    {
        '@type': 'tristate',
        key: 'ce80855f-1c1a-45e3-8f17-a1054c6d7bbf',
        label: 'Victime en cours de ski ou avec un groupe accompagné',
        value: bilan => bilan?.fiche_collision?.victime_cours_groupe,
    },
    {
        '@type': 'text',
        key: 'ac58efb0-6dab-4b8a-8edc-a27362bb6132',
        label: 'Nom du cours/groupe',
        value: bilan => bilan?.fiche_collision?.victime_nom_cours_groupe,
    },
    {
        '@type': 'uuid-string',
        key: '5beda154-33f1-4e5e-b10c-a7a0c75ebbff',
        label: 'Constat gendarmerie',
        value: bilan => bilan?.fiche_collision?.constat_gendarmerie,
    },
    {
        '@type': 'tristate',
        key: '1ebe8ed2-a726-4374-9224-e15aa9083dc3',
        label: 'Constat RM',
        value: bilan => bilan?.fiche_collision?.constat_rm,
    },
    {
        '@type': 'uuid-array',
        key: '61a3ca2c-d8b3-491c-af30-7e38d8868f2f',
        label: 'Détails précis visibles',
        value: bilan => bilan?.fiche_collision?.details_precis_visibles,
    },
    {
        '@type': 'uuid-string',
        key: '52240158-3972-417e-9bc2-b43faab441b8',
        label: 'Responsabilité',
        value: bilan => bilan?.fiche_collision?.responsabilite,
    },
];
exports.collisionSheetTemoinsExcel = [
    {
        '@type': 'text',
        key: '7d16f56d-5f85-4d77-8c78-8b55b7b3562d',
        label: 'Nom complet',
        value: elem => elem?.fullName,
    },
    {
        '@type': 'text',
        key: '4397b5fe-817d-4c50-9d63-092d82804e52',
        label: 'Adresse',
        value: elem => elem?.address,
    },
    {
        '@type': 'text',
        key: '23131827-fbe6-4426-bd18-85a35ca27c9e',
        label: 'N° téléphone',
        value: elem => elem?.phoneNumber,
    },
    {
        '@type': 'text',
        key: 'a6ac2f56-6ade-455d-8f38-5aebc5d71de3',
        label: 'Mail',
        value: elem => elem?.mail,
    },
    {
        '@type': 'text',
        key: '542c4fc8-c37f-4354-899a-6fe902821217',
        label: 'Assurance',
        value: elem => elem?.assurance,
    },
];
const makeCollisionSheetTemoins = () => {
    return [
        {
            '@type': 'tableItem',
            key: 'fd6fa39a-f998-4e1f-9ff3-154d01c129f1',
            children: [...exports.collisionSheetTemoinsExcel],
        },
    ];
};
exports.makeCollisionSheetTemoins = makeCollisionSheetTemoins;
exports.collisionSheetTemoins = [
    {
        '@type': 'tristate',
        key: 'bd8b07fb-69ba-4833-a7db-9ea76bf2ea41',
        label: 'Présence de témoins',
        value: bilan => bilan?.fiche_collision?.temoins,
    },
    {
        '@type': 'tristate',
        key: '7e9d242c-64cc-4683-9545-7de342b59ce5',
        label: 'Témoins présents sur les lieux',
        value: bilan => bilan?.fiche_collision?.temoins_restes_sur_place,
    },
    {
        '@type': 'table',
        key: 'e078386a-f632-43e7-857e-ddba0ddfbcdc',
        label: 'Témoins',
        value: (bilan) => bilan?.collision_temoin_identities || [],
        template: 'COLLISION_SHEET_TEMOINS',
    },
];
exports.collisionSheetCollisionObstacles = [
    {
        '@type': 'uuid-array',
        key: 'da90ed88-cdae-42e4-9d01-10a5e15eb728',
        label: "Type d'obstacle",
        value: bilan => bilan?.fiche_collision?.type_obstacles,
    },
    {
        '@type': 'tristate',
        key: '643ae07c-0e7e-467c-b01d-ddea82c680dd',
        label: "Obstacle visible de l'amont",
        value: bilan => bilan?.fiche_collision?.obstable_visible_amont,
    },
    {
        '@type': 'tristate',
        key: '7f1775cb-1343-4703-8f08-d63e16b9806f',
        label: 'Obstacle signalé',
        value: bilan => bilan?.fiche_collision?.obstable_signale,
    },
    {
        '@type': 'uuid-array',
        key: 'b166be4e-f901-4231-97e8-c16792977fac',
        label: "Signalisation / Protection de l'obstacle",
        value: bilan => bilan?.fiche_collision?.obstacle_signalisation_proctection,
    },
];
exports.collisionSheetTiersExcel = [
    {
        '@type': 'text',
        key: 'bed7610e-0b15-4445-9247-c109fe6a4a11',
        label: 'Nom complet',
        value: elem => elem?.fullName,
    },
    {
        '@type': 'text',
        key: 'cb08824c-f5ed-45f9-831d-1c059c287dce',
        label: 'Adresse',
        value: elem => elem?.address,
    },
    {
        '@type': 'text',
        key: '7a9555e8-3d5d-488f-8f28-bca15f9450e1',
        label: 'N° téléphone',
        value: elem => elem?.phoneNumber,
    },
    {
        '@type': 'text',
        key: '85962964-3660-43ff-a3bb-dce41394f28f',
        label: 'Mail',
        value: elem => elem?.mail,
    },
    {
        '@type': 'text',
        key: '9c6bc145-5d5c-4d18-bfb1-78e3158ccd77',
        label: 'Assurance',
        value: elem => elem?.assurance,
    },
];
const makeCollisionSheetTiers = () => {
    return [
        {
            '@type': 'tableItem',
            key: 'c873d5bc-a477-49da-a067-c22d31a34ce4',
            children: [...exports.collisionSheetTiersExcel],
        },
    ];
};
exports.makeCollisionSheetTiers = makeCollisionSheetTiers;
exports.collisionSheetImpliquesExcel = [
    {
        '@type': 'uuid-string',
        key: 'd54edec8-24c4-4600-86bf-3fa14bce4dab',
        label: 'Activité',
        value: elem => elem?.activity,
    },
    {
        '@type': 'uuid-string',
        key: 'ef5fe827-c768-4220-9410-f598585e3684',
        label: 'Niveau',
        value: elem => elem?.tech_level,
    },
    {
        '@type': 'uuid-string',
        key: '0eec80f4-9119-402e-9920-f2bbdd196fdf',
        label: 'Vitesse',
        value: elem => elem?.cinetic,
    },
    {
        '@type': 'text',
        key: 'a69b0fce-201b-4662-b5c4-0553a3cc6fa2',
        label: 'Cours/Groupe',
        value: elem => elem?.nom_cours_groupe,
    },
];
const makeCollisionSheetImpliques = () => {
    return [
        {
            '@type': 'tableItem',
            key: 'c18b9250-618f-4442-adef-c5e5f9408d00',
            children: [...exports.collisionSheetImpliquesExcel],
        },
    ];
};
exports.makeCollisionSheetImpliques = makeCollisionSheetImpliques;
exports.collisionSheetCollisionTiers = [
    {
        '@type': 'tristate',
        key: '405103c3-8d19-45ab-908a-9630d945370f',
        label: "Victime visible de l'amont",
        value: bilan => bilan?.fiche_collision?.victime_visible_amont,
    },
    {
        '@type': 'tristate',
        key: '3019a3d6-413b-4050-93f2-7a3c3dceac99',
        label: 'Tiers impliqués restés sur les lieux',
        value: bilan => bilan?.fiche_collision?.tiers_impliques_restes_sur_place,
    },
    {
        '@type': 'table',
        key: '40e08849-cc0c-4429-987a-f3cd4a6b6f9d',
        label: 'Tiers',
        value: (bilan) => bilan?.collision_tier_identities || [],
        template: 'COLLISION_SHEET_TIERS',
    },
    {
        '@type': 'table',
        key: 'fcf7cc2c-9f04-4115-8464-29ca9bc3d2e8',
        label: 'Impliqués',
        value: (bilan) => bilan?.collision_implicates || [],
        template: 'COLLISION_SHEET_IMPLIQUES',
    },
];
